export const AssociationStatus = Object.freeze({
  "1": {label: 'linked', value: 1, className: "bg-green-50 border border-green-400 font-semibold text-sm text-green-500"},
  "-1": {label: 'pending', value: -1, className: "bg-blue-100 border border-blue-400 font-semibold text-sm text-blue-500"},
  "-2": {label: 'rejected', value: -2, className: "bg-primary-50 border border-primary-400 font-semibold text-sm text-primary-500"}
});

export const OrgType2Association = Object.freeze({
  "300": {value: "parish", label: 'parish', enabled: true},
  "302": {value: "diocese", label: 'diocese', enabled: true},
  "400": {value: "religious_order", label: 'religious orders', enabled: true},
  "100": {value: "undefined", label: 'organization'},
  "102": {value: "undefined", label: 'community'},
  "104": {value: "undefined", label: 'school'},
  "999": {value: "undefined", label: 'group'},
});

